window.__tnt || (window.__tnt = {});
__tnt.video || (__tnt.video = {});

__tnt.video.vast = {
    url:function(url,keywords){
        var date = new Date();
	 
            keywords = [
                {'key':/%%canonical_url%%/g, 'value': canonicalUrl},
                {'key':/%%full_url%%/g, 'value': fullUrl },
                {'key':/%%timestamp%%/g, 'value': date.getTime()},
                {'key':/%%width%%/g, 'value': vidWidth },
                {'key':/%%height%%/g, 'value': vidHeight },
                {'key':/%%random%%/g, 'value': Math.trunc(Math.random()*Math.pow(10,6))},
                {'key':/%%keywords%%/g, 'value': keywordsString },
                {'key':/%%path%%/g, 'value': pathname }
            ];
	    
        if(typeof(url)!='undefined'){
            $.each(keywords,function(){
                url = url.replace(this.key, this.value);
            });
	        
            return url;
        }
    }
};

__tnt.video.plugins = {};

__tnt.video.advertising = function(player){
    __tnt.video.register(player);
           
    player.one('play', function(){
        jQuery.ajax({
            type: "GET",
            url:  __tnt.video.vastUrl,
            dataType:"xml",
            cache:"false",
            success: function(result){
                console.log('Video Player - IMA - Vast Feed Retrieved Successfully');
            },
            complete: function(result,status){
                console.log('Video Player - IMA - Vast feed retrieval complete');
                
                var options = {
                    id: player.id(),
                    adsResponse: result.responseText // Ads response needs the full text of the vast feed
                    
                }

                if(typeof(player.ima)==='function'){
                    player.ima(options);
                }

                player.ima.initializeAdDisplayContainer();
                player.ima.requestAds();
                player.play();
                
                if(navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > 0){                
                setTimeout(function () {
                    __tnt.log("VIDEO - FIXING BROKEN IE BEHAVIOR");   
                    var adContainer = $('.ima-ad-container').find('iframe'); // ('#'+player.id()).find
                    
                    var adWidth = $('#'+player.id()).width();
                    var adHeight = (adWidth/16)*9;
                    
                    player.height(adHeight);

                    adContainer.parent().height(adHeight);
                    adContainer.height(adHeight);
                    adContainer.parent().height(adHeight);


                }, 500);
                }
                
            },
            error: function(XMLHttpRequest, textStatus, errorThrown){
                console.log(textStatus+": "+errorThrown);
            }
        });
    });
};
